// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import kanjiDictionary from "../consts/kanjiDictionary";
import { convertRomajiValue } from "./romajiConverter";

export const MAX_CORRECTION_SUGGESTIONS = 3;

const hiraganaWordPattern = /^[\u3041-\u3096]+$/;
const romajiWordPattern = /^[a-z]+$/i;

function editDistance(left, right) {
    const previous = Array.from({ length: right.length + 1 }, (_, index) => index);

    for (let leftIndex = 1; leftIndex <= left.length; leftIndex += 1) {
        const current = [leftIndex];
        for (let rightIndex = 1; rightIndex <= right.length; rightIndex += 1) {
            current[rightIndex] = Math.min(
                current[rightIndex - 1] + 1,
                previous[rightIndex] + 1,
                previous[rightIndex - 1] + Number(left[leftIndex - 1] !== right[rightIndex - 1])
            );
        }
        previous.splice(0, previous.length, ...current);
    }

    return previous[right.length];
}

export function normalizeCorrectionInput(value, romajiMap) {
    const trimmed = String(value || "").trim().normalize("NFC");

    if (hiraganaWordPattern.test(trimmed)) {
        return { reading: trimmed, source: "hiragana" };
    }

    if (!romajiWordPattern.test(trimmed)) return null;

    const normalizedRomaji = trimmed.toLowerCase();
    const { produced, remainder } = convertRomajiValue(normalizedRomaji, romajiMap, false);

    if (remainder) return null;
    return { reading: produced, source: "romaji", romaji: normalizedRomaji };
}

export function getWordCorrections(value, romajiMap) {
    const normalized = normalizeCorrectionInput(value, romajiMap);
    if (!normalized) return [];

    if (kanjiDictionary.some((entry) => entry.reading === normalized.reading)) {
        return [];
    }

    return kanjiDictionary
        .filter((entry) => entry.romaji && entry.meanings?.length)
        .map((entry, sourceIndex) => ({
            entry,
            sourceIndex,
            distance: editDistance(normalized.reading, entry.reading)
        }))
        .filter(({ distance }) => distance === 1)
        .sort((left, right) =>
            left.distance - right.distance ||
            Number(Boolean(right.entry.common)) - Number(Boolean(left.entry.common)) ||
            left.sourceIndex - right.sourceIndex
        )
        .slice(0, MAX_CORRECTION_SUGGESTIONS)
        .map(({ entry }) => ({
            correct: entry.candidates[0],
            reading: entry.reading,
            romaji: entry.romaji,
            meaning: entry.meanings[0]
        }));
}
